import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import { load, updateFilter, loadAutocomplete } from 'Actions/journal';
import DataTable from 'Components/DataTable';
import Header from 'Components/Header';
import { pageTitleDecorator, authenticatedPageDecorator } from 'Decorators';
import { QueryFilterType, JournalType, DataTableMetadataType } from 'Types';
import {
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
    DATA_TABLE_COLUMN_TYPE_STATUS,
    ROLE_ADMIN, DATA_TABLE_COLUMN_TYPE_LINK,
} from 'Constants';
import Button from 'Common/CustomButtons/Button';
import { FormattedMessage } from 'react-intl';
import Loader from 'Common/Loader/Loader';

@authenticatedPageDecorator([ROLE_ADMIN])
@pageTitleDecorator('journals')
@connect(
    store => ({
        loading: store.journalsList.loading,
        success: store.journalsList.success,
        error: store.journalsList.error,
        data: store.journalsList.data,
        filter: store.journalsList.filter,
        metadata: store.journalsList.metadata,
        dataAutocomplete: store.journalsListAutocomplete.data,
        filterAutocomplete: store.journalsListAutocomplete.filter,
    }),
    dispatch => ({
        load: filter => dispatch(load(filter)),
        updateFilter: filter => dispatch(updateFilter(filter)),
        loadAutocomplete: filter => dispatch(loadAutocomplete(filter)),
        redirectToCreate: () => dispatch(push('/journals/create')),
    })
)
export default class JournalsList extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        error: PropTypes.bool.isRequired,
        data: PropTypes.arrayOf(JournalType),
        filter: QueryFilterType,
        metadata: DataTableMetadataType,
        load: PropTypes.func.isRequired,
        updateFilter: PropTypes.func.isRequired,
        dataAutocomplete: PropTypes.arrayOf(JournalType),
        filterAutocomplete: QueryFilterType,
        loadAutocomplete: PropTypes.func,
        redirectToCreate: PropTypes.func,
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const { updateFilter } = this.props;
        updateFilter({where: {}, has: {}, order: 'title asc'});
    }


    loadOptions = input => {
        const { filterAutocomplete } = this.props;
        const where = {
            title: { like: `%${input}%` },
        };
        const filter = filterAutocomplete.merge({
            where,
        });
        this.props.loadAutocomplete(filter);
    };

    getColumns = () => {
        const { dataAutocomplete } = this.props;

        return [
            {
                key: 'id',
                col: { width: '5%' },
                title: 'data_table.id',
                filterPlaceholder: 'data_table.filter.id',
                sortable: true,
            },
            {
                key: 'title',
                col: { width: '40%' },
                title: 'data_table.title',
                type: DATA_TABLE_COLUMN_TYPE_LINK,
                link: {
                    to: '/journals/:id',
                    placeholders: {
                        id: item => item.id
                    }
                },
                filterType: DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
                loadOptions: this.loadOptions,
                options: dataAutocomplete.map(item => ({
                    value: item.title,
                    label: item.title,
                })),
                sortable: true,
                filterable: true,
                filterPlaceholder: 'data_table.filter.journal_title',
            },
            {
                col: { width: '40%' },
                key: 'founder',
                title: 'data_table.founder',
                type: 'string',
                sortable: true,
            },
            {
                col: { width: '10%' },
                key: 'issn_print',
                title: 'data_table.issn_print',
                type: 'string',
                sortable: true,
            },
            {
                col: { width: '10%' },
                key: 'issn_online',
                title: 'data_table.issn_online',
                type: 'string',
                sortable: true,
            },
            {
                col: { width: '10%' },
                key: 'is_active',
                title: 'data_table.is_active',
                type: DATA_TABLE_COLUMN_TYPE_STATUS,
                sortable: true,
            }
        ];
    };

    render() {
        const { data, filter, load, metadata, updateFilter, loading } = this.props;
        return (
            <div className="wrapJournalList">
                {loading && <Loader/>}

                <Header title="title.journals">
                    <Button  color="primary" onClick={this.props.redirectToCreate}>
                        <FormattedMessage id="button.journal.create.link" />
                    </Button>
                </Header>

                <DataTable
                    columns={this.getColumns()}
                    metadata={metadata}
                    data={data}
                    filter={filter}
                    load={load}
                    updateFilter={updateFilter}
                    icon={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/JournalsList/JournalsList.jsx